/**
 * Backwards-compatible re-export of the generic shared
 * `useFacetedExplorer` hook.
 *
 * Per ADMIN_DOMAIN_RC_AUDIT_2026 §19.4 P1-1 the implementation has been
 * promoted to `src/portals/shared/useFacetedExplorer.ts` so other portals
 * (teacher, parent) can reuse the same explorer mechanics — multi-criteria
 * filtering, localStorage persistence, snapshot/restore expand state,
 * force-open during filtering.
 *
 * Existing admin callers can keep importing `useRegistryFilters` and
 * `SortMode` from this module without code changes.
 */
export {
  useFacetedExplorer as useRegistryFilters,
  type FacetedSortMode as SortMode,
  type FacetedFilterState,
  type FacetedItem,
  type FacetStatus,
  type FacetedViewMode,
  type UseFacetedExplorerOptions,
} from '../../../../shared/useFacetedExplorer'
